import { BaseService } from "./BaseService";

export class SheetOptionService extends BaseService {
  getCurrencyHedge(profileid): any {
    return super.invokeGet(this.APICONFIG.APIBASEURL + this.APICONFIG.GETCURRENCYHEDGE + "?profileID=" + profileid);
  }
}
